<template>
  <div class="game-list">
    <div
      v-for="(game, index) in games"
      :key="getGameKey(game, index)"
      class="game-list-item"
    >
      <GameCard
        v-if="expandedGameId === getGameId(game, index)"
        :game="game"
        :rank="index + 1"
        @collapse="collapseGame"
      />

      <GamePreviewCard
        v-else
        :game="game"
        @expand="expandGame(game, index)"
      />
    </div>
  </div>
</template>

<script>
import GameCard from './GameCard.vue';
import GamePreviewCard from './GamePreviewCard.vue';

export default {
  name: 'GameList',
  components: {
    GameCard,
    GamePreviewCard,
  },
  props: {
    games: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      expandedGameId: null,
    };
  },
  methods: {
    getGameId(game, index) {
      return game.id || game.app_id || game.steam_appid || game.name || index;
    },
    getGameKey(game, index) {
      return this.getGameId(game, index);
    },
    expandGame(game, index) {
      this.expandedGameId = this.getGameId(game, index);
    },
    collapseGame() {
      this.expandedGameId = null;
    },
  },
};
</script>

<style scoped>
.game-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
}

.game-list-item {
  width: 100%;
}
</style>